import React from 'react'

import { IService } from '../interfaces/IService'

export const ServiceListItem = ({
  title,
  slug,
  excerpt,
  featuredImage,
}: IService) => {
  return (
    <li>
      <a
        className="service-link grid gap-4 md:gap-16 md:grid-cols-[auto,1fr] content-start"
        href={`/sluzba/${slug}`}
      >
        {featuredImage!.node!.sourceUrl! && (
          <img
            src={featuredImage!.node!.sourceUrl}
            alt={title!}
            width={93}
            height={93}
          />
        )}

        <div className="grid gap-4 md:gap-8 justify-items-start">
          <h3 className="font-semibold text-secondary text-3xl md:text-5xl leading-snug md:leading-loose">
            {title}
          </h3>

          <div dangerouslySetInnerHTML={{ __html: excerpt! }} />

          <span className="decoration-secondary decoration-2 font-semibold transition-all underline-offset-4 underline hover:underline-offset-8">
            Více informací
          </span>
        </div>
      </a>
    </li>
  )
}
